import { atom } from "jotai";

export const backPressHandlersAtom = atom<Array<() => void>>([]);
